import type React from 'react';
import { type IWidgetParsedProps } from '../../../../inputs/common/util/getWidgetProps.ts';
import { type ISubsectionWidget } from '../../ISubsectionWidget.ts';

export interface ISubsectionInlineComponentProps {
  widget: ISubsectionWidget;
  options: IWidgetParsedProps;
  children?: React.ReactNode;
}

export function SubsectionInlineComponent(
  props: ISubsectionInlineComponentProps,
) {
  return props.children;
}
